import React from 'react';
import EmailVerificationBanner from './EmailVerificationBanner';

const Layout = ({ sidebar, header, children }) => (
  <div className="uh-layout">
    <aside role="complementary">{sidebar}</aside>
    <main className="uh-main">
      {header && (
        <div className="uh-header">
          <div className="uh-header-row">{header}</div>
        </div>
      )}
      <div className="uh-content">
        <EmailVerificationBanner />
        {children}
      </div>
    </main>
  </div>
);

export default Layout;
